module.exports = __webpack_public_path__ + "static/media/dctst.4d10a633.png";